import { render, staticRenderFns } from "./SetProduct.vue?vue&type=template&id=2c4f4987&"
import script from "./SetProduct.vue?vue&type=script&lang=js&"
export * from "./SetProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports